export default function(key, value)
{
    localStorage.setItem(key, JSON.stringify(value));
}